<template>
    <div class="">
        <group-page-header title="Group Events">
            <span slot="additionalButtons" v-if="viewer_state.is_admin">
                <vue-folder-button
                        tabindex="0"
                        role="button"
                        icon-class="fa-plus"
                        text="Create Event"
                        aria-label="Create Event"
                        @click.native="createEvent"

                ></vue-folder-button>
            </span>
        </group-page-header>
        <group-events-page
                class="margin-10-top"
                :group="group"
        ></group-events-page>
    </div>
</template>

<script>
    import GroupEventsPage from "../groups/group_events/GroupEventsPage";
    import {mapGetters} from "vuex";
    import GroupPageHeader from "./common/GroupPageHeader";
    import Vue from "vue";
    import CreateEventPopup from "../events/new_event/CreateEventPopup";
    import {simplePopupFactory} from "shared/simple_popups/simplePopupFactory";
    import CalendarEventsResource from "../events/calendar_events_recource";

    export default {
        name: "GroupPageEvents",
        components: {GroupPageHeader, GroupEventsPage},
        computed: {
            ...mapGetters('groupPage', {group: 'group', viewer_state: 'viewer_state'}),
        },
        methods: {
            createEvent() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                const {vm, popupComponent, fEl} = simplePopupFactory.mount_vue_popup(CreateEventPopup);
                popupComponent.show({privateEvent: false}, {
                    header: `Create Group Event in ${this.group.name}`,
                    privateLabel: `Make this a Private Event. (Hide from un-invited Group members)`,
                    privateHelpText: null
                })
                    .then(eventData => {
                        $rootScope.show_dimmer();
                        return CalendarEventsResource($http).create_calendar_event({
                            target: 'group',
                            group_id: this.group.id
                        }, eventData);
                    }, () => new Promise(() => {
                        vm?.$destroy();
                        fEl?.focus();
                    }))
                    .then(resp => {
                        document.location.href = this.$options.filters.backHref(resp.data.link);
                        Vue.notifications.success('Created');
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    })
                    .finally(() => {
                        vm?.$destroy();
                        fEl?.focus();
                    });
            }
        }
    };
</script>
<style lang="scss" scoped>
  @import "commonStyle";
</style>
